import { useState } from 'react'
import Migration from './pages/Migration'

function App() {

  return (
    <Migration />
  )
}

export default App
